import styled from "styled-components";

export const Label = styled.label`
    border-radius: 40px;
    outline: none;
    border-style: solid;
    border-width: 1.5px;
    cursor: pointer;
    background: #f3f0fd;
    color: #8868ea;
    border: none;
    padding: 10px 10px;
    font-weight: 600;
    height: fit-content;
    align-self: center;

    &:hover {
        transition: 0.15s all ease-in-out;
        box-shadow: 0px 4px 14px rgba(136, 104, 234, 0.3);
    }
`;

export const Input = styled.input`
    display: none;
`;

export const HalfContainer = styled.div`
    width: 80%;
    margin: 1.5rem 10px;
    margin-top: 0;
`;

export const HorizontalSeparator = styled.div<{
    width?: string;
    margin?: string;
}>`
    width: ${({ width }) => (width ? width : "100%")};
    margin: ${({ margin }) => margin && margin};
    border-bottom: 1px solid #e0e7ec;
`;
